<template>
  <v-layout column>
    <v-flex>
      <v-layout align-center>
        <v-layout class="title px-3 py-0">
          <pre>Звено </pre>
          <pre class="font-weight-bold">Свозка</pre>
          <v-spacer />
          <span class="font-weight-bold">{{ route ? route : "" }}</span>
          <v-spacer />
          <span class="font-weight-bold">{{ vehicle ? vehicle : "" }}</span>
        </v-layout>
        <v-spacer />
        <h2 class="subheading font-weight-bold pa-3">
          <span
            :class="{
              'orange--text': phasesState.id == phaseStates.AWAITING,
              'green--text': phasesState.id == phaseStates.DONE
            }"
          >{{ phasesState.title }}</span>
        </h2>
        <v-btn
          v-if="isPhasesStateChange"
          :disabled="isNew || isChanged || disabledState || disabled"
          color="primary ml-0 mr-3"
          small
          @click="phasesStateChanged"
        >
          {{
            phasesState.id == phaseStates.AWAITING
              ? "Завершить"
              : phasesState.id == phaseStates.DONE
                ? "В ожидании"
                : ""
          }}
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-form
        v-model="valid"
        class="pa-3"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <v-text-field
              v-model="sendingPoint"
              class="ma-1"
              label="Отправка"
              disabled
              hide-details
              outline
              height="44"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <v-text-field
              v-model="sendingPointAddress"
              class="ma-1"
              label="Адрес погрузки*"
              disabled
              hide-details
              outline
              height="44"
            />
          </v-flex>
        </v-layout>
        <v-flex
          md12
          xs12
        >
          <v-radio-group
            v-model="counterpartyType"
            hide-details
            row
            class="mt-2 mb-1"
            @change="counterpartyTypeChanged"
          >
            <h2 class="subheading mx-2">
              Тип контрагента:
            </h2>
            <v-radio
              v-for="(item, value) in counterpartyTypes"
              :key="value"
              :label="item.text"
              :value="item"
              :disabled="isDisabledPhase"
            />
          </v-radio-group>
        </v-flex>
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <app-reference
              v-model="counterparty"
              class="ma-1"
              :outline="true"
              label="Контрагент*"
              :rules="[v => !!v || '']"
              required
              :resource="counterpartyType.resource"
              :component-name="counterpartyType.value"
              :disabled="isDisabledPhase"
              :height-field="44"
              @input="counterpartyChanged"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <v-list>
              <v-list-tile
                class="pa-0"
                :disabled="isDisabledPhase"
              >
                <h2 class="subheading mr-2">
                  К свозке
                </h2>
                <v-list-tile-action>
                  <v-menu offset-y>
                    <v-btn
                      slot="activator"
                      class="white--text"
                      small
                      :color="readyForCombination === false ? 'red' : 'green'"
                      @change="phaseChanged"
                    >
                      {{ readyForCombination === false ? "Нет" : "Да" }}
                    </v-btn>
                    <v-list>
                      <v-list-tile
                        v-if="readyForCombination === false"
                        @click="readyForCombinationChanged"
                      >
                        <v-list-tile-title>Да</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        v-if="readyForCombination === true"
                        @click="readyForCombinationChanged"
                      >
                        <v-list-tile-title>Нет</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
        <v-flex>
          <v-radio-group
            v-model="arrivalType"
            hide-details
            row
            class="mt-0 mb-1"
          >
            <h2
              :class="[
                { 'grey--text': phasesState.id == phaseStates.DONE },
                'subheading',
                'mx-2'
              ]"
            >
              Место прибытия:
            </h2>
            <v-layout
              row
              wrap
            >
              <v-radio
                v-for="(item, value) in arrivalTypes"
                :key="value"
                :label="item.text"
                :value="item"
                :disabled="isDisabledPhase"
                @change="arrivalChanged"
              />
            </v-layout>
          </v-radio-group>
        </v-flex>
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <app-reference
              v-if="arrivalType.value !== unloadingPlaceTypes.ADDRESS"
              v-model="arrivalPoint"
              class="ma-1"
              label="Прибытие*"
              :disabled="isDisabledPhase"
              :resource="arrivalType.resource"
              :component-name="arrivalType.component"
              :filter-name="
                arrivalType.value === unloadingPlaceTypes.GROUPEDWAREHOUSE ||
                  arrivalType.value === unloadingPlaceTypes.OTHERWAREHOUSE
                  ? 'groupedWarehouse'
                  : ''
              "
              :filter-value="
                arrivalType.value === unloadingPlaceTypes.GROUPEDWAREHOUSE
                  ? true
                  : arrivalType.value === unloadingPlaceTypes.OTHERWAREHOUSE
                    ? false
                    : null
              "
              :outline="true"
              :height-field="44"
              :rules="[v => !!v || '']"
              required
              @input="arrivalPointChanged"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <ArrivalPlaceReference
              v-if="arrivalType.value == unloadingPlaceTypes.FACTORY"
              v-model="arrivalPointAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :factory-id="arrivalPoint ? arrivalPoint.id : 0"
              :disabled="isDisabledPhase"
              @input="phaseChanged"
            />
            <v-text-field
              v-if="
                arrivalType.value == unloadingPlaceTypes.GROUPEDWAREHOUSE ||
                  arrivalType.value == unloadingPlaceTypes.OTHERWAREHOUSE
              "
              v-model="arrivalPointWarehouseAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :rules="[v => !!v || '']"
              hide-details
              outline
              height="44"
              :disabled="isDisabledPhase"
              @change="phaseChanged"
            />
          </v-flex>
          <v-flex
            v-if="arrivalType.value == unloadingPlaceTypes.ADDRESS"
            md12
            xs12
          >
            <app-reference
              v-model="arrivalPointAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :resource="arrivalType.resource"
              :component-name="arrivalType.component"
              :parent-id="arrivalPoint ? arrivalPoint.id : 0"
              :rules="[v => !!v || '']"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              @input="phaseChanged"
            />
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <app-date-picker
              v-model="loadingDate"
              class="ma-1"
              label="Дата погрузки"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              :without-initial-data="true"
              :with-autocomplete="true"
              :clearable="true"
              @input="phaseChanged"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <app-date-picker
              v-model="unloadingDate"
              class="ma-1"
              label="Дата прибытия"
              :min="loadingDate"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              :without-initial-data="true"
              :with-autocomplete="true"
              :clearable="true"
              @input="phaseChanged"
            />
          </v-flex>
        </v-layout>
        <v-flex
          v-if="isNew"
          class="mb-3"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-textarea
                v-model="notes"
                class="ma-1"
                label="Комментарий"
                hide-details
                rows="1"
                auto-grow
                outline
                v-bind="attrs"
                @change="phaseChanged"
                v-on="on"
              />
            </template>
            <span>Страховка, тип загрузки, хрупкость, нюансы погрузки и
              другое</span>
          </v-tooltip>
        </v-flex>
        <HistoryComments
          v-else
          :comments="currentComments"
          :loading="phaseLoading"
          tooltip="Страховка, тип загрузки, хрупкость, нюансы погрузки и другое"
          :is-disabled-add="isDisabledAddComment"
          @add="addComment"
          @delete="deleteComment"
        />
        <v-layout
          align-center
          justify-end
        >
          <v-flex>
            <v-btn
              small
              color="primary"
              class="mt-3"
              :disabled="!valid || !isChanged"
              :loading="phaseLoading"
              @click="save"
            >
              Сохранить
            </v-btn>
            <v-btn
              small
              class="mt-3"
              @click="$emit('cancel')"
            >
              Oтмена
            </v-btn>
          </v-flex>
          <v-spacer />
          <v-menu
            offset-y
            left
            top
          >
            <template v-slot:activator="{ on }">
              <DeletePhasesButton
                :is-in-route="isInRoute"
                :disabled="isDeletePhasesButtonDisabled"
                v-on="on"
              />
            </template>
            <v-card>
              <v-card-title>
                Вы действительно хотите удалить звено?
              </v-card-title>
              <v-card-actions>
                <v-layout
                  align-center
                  justify-end
                >
                  <v-btn
                    small
                    flat
                    color="primary"
                    @click="remove"
                  >
                    Ок
                  </v-btn>
                  <v-btn
                    small
                    flat
                    @click="$emit('cancel')"
                  >
                    Отменить
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import ArrivalPlaceReference from "./ArrivalPlaceReference.vue";
import HistoryComments from "../../../../components/HistoryComments.vue";
import DeletePhasesButton from "./DeletePhasesButton.vue";
import { phaseStates } from "./shipping-phase-states.js";
import * as shippingsApi from "../../../../backend/shippingsApi.js";
import * as phasesApi from "../../../../backend/phasesApi.js";
import { unloadingPlaceTypes } from "../../../../enums/unloading-place-types.js";
import { userRoles } from "../../../../enums/user-roles.js";

export default {
  components: {
    ArrivalPlaceReference,
    HistoryComments,
    DeletePhasesButton,
  },
  props: [
    "value",
    "isLastPhase",
    "disabled",
    "user",
    "fromRoute",
    "isDisabledAddComment",
  ],
  data() {
    return {
      valid: true,
      counterpartyTypes: [
        { value: "warehouse", text: "Склад", resource: "warehouses" },
        { value: "carrier", text: "Перевозчик", resource: "carriers" },
        { value: "client", text: "Клиент", resource: "clients" },
      ],
      counterpartyType: {
        value: "warehouse",
        text: "Склад",
        resource: "warehouses",
      },
      arrivalType: null,
      isChanged: false,
      counterparty: null,
      readyForCombination: false,
      arrivalPoint: null,
      arrivalPointAddress: null,
      loadingDate: null,
      unloadingDate: null,
      senderFactory: null,
      senderWarehouse: null,
      senderAddress: null,
      notes: "",
      currentComments: [],
      phasesState: null,
      isNew: false,
      phaseLoading: false,
    };
  },
  computed: {
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    isAdmin() {
      return !!this.user.roles.find(r => r.id === userRoles.Admin);
    },
    sendingPoint() {
      return this.senderFactory?.title || this.senderWarehouse?.title || "";
    },
    sendingPointAddress() {
      return this.senderAddress?.title || "";
    },
    phaseStates() {
      return phaseStates;
    },
    arrivalTypes() {
      return [
        {
          value: unloadingPlaceTypes.FACTORY,
          text: "Склад продавца",
          resource: "factories",
          component: "Factory",
        },
        {
          value: unloadingPlaceTypes.GROUPEDWAREHOUSE,
          text: "Группажный склад",
          resource: "warehouses",
          component: "Warehouse",
        },
        {
          value: unloadingPlaceTypes.ADDRESS,
          text: "Другое",
          resource: "addresses",
          component: "Address",
        },
        {
          value: unloadingPlaceTypes.OTHERWAREHOUSE,
          text: "Другой склад",
          resource: "warehouses",
          component: "Warehouse",
        },
      ];
    },
    shippingSender() {
      return this.$store.getters["shipping/sender"];
    },
    shippingSenderAddress() {
      return this.$store.getters["shipping/senderAddress"];
    },
    shippingId() {
      return this.$store.getters["shipping/id"];
    },
    disabledState() {
      return this.$store.getters["shipping/disabledState"];
    },
    unloadingPlaceTypes() {
      return unloadingPlaceTypes;
    },
    arrivalPointWarehouseAddress() {
      return this.arrivalPointAddress?.title || "";
    },
    route() {
      return this.value?.route?.title || "";
    },
    vehicle() {
      return this.value?.vehicle?.title || "";
    },
    isDisabledPhase() {
      return this.phasesState.id == phaseStates.DONE || this.disabled;
    },
    phasesWithRerouting() {
      return this.$store.getters["shipping/phasesWithRerouting"];
    },
    isDeletePhasesButtonDisabled() {
      return (
        this.isNew ||
        this.phasesState.id != this.phaseStates.AWAITING ||
        !this.isLastPhase ||
        this.disabled
      );
    },
    isInRoute() {
      return !!this.route;
    },
    isPhasesStateChange() {
      return this.value?.changeState || true;
    },
  },
  created() {
    this.initSenderPoint();
    if (this.value) {
      this.initPhase(this.value);
    } else {
      this.isNew = true;
      this.phasesState = this.getPhasesState(phaseStates.AWAITING);
      this.arrivalType = this.arrivalTypes[3];
      this.arrivalChanged();
    }
  },
  beforeDestroy() {
    if (!this.phasesWithRerouting.length) {
      return;
    }
    this.$store.dispatch("shipping/unmarkPhasesWithRerouting", {
      shippingId: this.shippingId,
      phaseId: this.value.id,
    });
  },
  methods: {
    initSenderPoint() {
      if (this.phases.length > 0 && !this.value) {
        const lastPhase = this.phases[this.phases.length - 1];
        this.senderFactory = lastPhase.arrivalPoint?.factory;
        this.senderWarehouse = lastPhase.arrivalPoint?.warehouse;
        this.senderAddress = lastPhase.arrivalPoint?.address;
      } else if (this.phases.length === 0 && !this.value) {
        this.senderFactory =
          this.shippingSender.type === 0 ? this.shippingSender : null;
        this.senderWarehouse =
          this.shippingSender.type === 1 ? this.shippingSender : null;
        this.senderAddress = this.shippingSenderAddress;
      }
    },
    initPhase(value) {
      this.counterpartyType = value.counterparty.carrier
        ? this.counterpartyTypes[1]
        : value.counterparty.client
          ? this.counterpartyTypes[2]
          : this.counterpartyTypes[0];
      this.counterparty = value.counterparty.carrier
        ? value.counterparty.carrier
        : value.counterparty.client
          ? value.counterparty.client
          : value.counterparty.warehouse
            ? value.counterparty.warehouse
            : null;
      this.arrivalType = value.arrivalPoint.factory
        ? this.arrivalTypes[0]
        : value.arrivalPoint.warehouse &&
          value.arrivalPoint.warehouse.groupedWarehouse
          ? this.arrivalTypes[1]
          : value.arrivalPoint.warehouse &&
          !value.arrivalPoint.warehouse.groupedWarehouse
            ? this.arrivalTypes[3]
            : this.arrivalTypes[2];
      this.readyForCombination = value.readyForCombination;
      this.arrivalPoint = value.arrivalPoint.factory
        ? value.arrivalPoint.factory
        : value.arrivalPoint.warehouse
          ? value.arrivalPoint.warehouse
          : null;
      this.arrivalPointAddress = value.arrivalPoint?.address;
      this.loadingDate = value.loadingDate;
      this.unloadingDate = value.unloadingDate;
      this.senderFactory = value.sendingPoint?.factory;
      this.senderWarehouse = value.sendingPoint?.warehouse;
      this.senderAddress = value.sendingPoint?.address;
      this.phasesState = this.getPhasesState(value.state.id);
      this.currentComments = value.comments;
      this.markAsReadComments();
    },
    async save() {
      this.phaseLoading = true;
      const phase = {
        counterpartyWarehouseId:
          this.counterpartyType.value === "warehouse"
            ? this.counterparty.id
            : null,
        counterpartyCarrierId:
          this.counterpartyType.value === "carrier"
            ? this.counterparty.id
            : null,
        counterpartyClientId:
          this.counterpartyType.value === "client"
            ? this.counterparty.id
            : null,
        arrivalPointWarehouseId:
          this.arrivalType.value ===
            this.unloadingPlaceTypes.GROUPEDWAREHOUSE ||
          this.arrivalType.value === this.unloadingPlaceTypes.OTHERWAREHOUSE
            ? this.arrivalPoint.id
            : null,
        arrivalPointFactoryId:
          this.arrivalType.value === this.unloadingPlaceTypes.FACTORY
            ? this.arrivalPoint.id
            : null,
        arrivalPointAddressId: this.arrivalPointAddress.id,
        sendingPointWarehouseId: this.senderWarehouse?.id,
        sendingPointFactoryId: this.senderFactory?.id,
        sendingPointAddressId: this.senderAddress.id,
        readyForCombination: this.readyForCombination,
        loadingDate: this.loadingDate,
        unloadingDate: this.unloadingDate,
      };

      let phaseId = 0;
      if (!this.value) {
        phaseId = await phasesApi.createCombinationPhase(
          this.shippingId,
          phase,
        );
      } else {
        await phasesApi.updateCombinationPhase(
          this.shippingId,
          this.value.id,
          phase,
          this.fromRoute,
        );
      }
      if (this.notes) {
        await phasesApi.addComment(
          this.value?.id || phaseId,
          this.notes,
          this.fromRoute,
        );
      }
      this.showInfo(this.value ? "Изменения сохранены" : "Звено добавлено");
      if (this.fromRoute) {
        this.$emit("update");
      } else {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      this.$emit("cancel");
      this.phaseLoading = false;
    },
    counterpartyTypeChanged() {
      if (this.counterpartyType.value === "client") {
        this.counterparty = this.$store.getters["shipping/client"];
      } else {
        this.counterparty = null;
      }
      this.phaseChanged();
    },
    arrivalChanged() {
      this.arrivalPoint = null;
      this.arrivalPointAddress = null;
      this.phaseChanged();
    },
    async arrivalPointChanged() {
      if (!this.arrivalPoint) {
        this.arrivalPointAddress = null;
      }
      if (
        (this.arrivalType.value == this.unloadingPlaceTypes.GROUPEDWAREHOUSE &&
          this.arrivalPoint != null) ||
        (this.arrivalType.value == this.unloadingPlaceTypes.OTHERWAREHOUSE &&
          this.arrivalPoint != null)
      ) {
        const response = await shippingsApi.getWarehouse(this.arrivalPoint.id);
        this.arrivalPointAddress = {
          id: response.Address.Id,
          title: response.Address.Title,
        };
      }
      this.phaseChanged();
    },
    async counterpartyChanged() {
      if (!this.counterparty) return;
      if (
        this.arrivalType.value == this.unloadingPlaceTypes.GROUPEDWAREHOUSE ||
        this.arrivalType.value == this.unloadingPlaceTypes.OTHERWAREHOUSE
      ) {
        await shippingsApi.getWarehouse(this.counterparty.id);
      }
      this.phaseChanged();
    },
    async phasesStateChanged() {
      const stateId =
        this.phasesState.id == phaseStates.AWAITING
          ? phaseStates.DONE
          : phaseStates.AWAITING;

      this.phaseLoading = true;
      await phasesApi.updatePhasesState(
        this.shippingId,
        this.value.id,
        stateId,
      );
      this.showInfo("Статус изменен");
      if (!this.fromRoute) {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      if (stateId === phaseStates.DONE) {
        this.$store.dispatch("shipping/updateDates", this.shippingId);
      }
      this.$emit("cancel");
      this.phaseLoading = false;
    },
    async remove() {
      this.phaseLoading = true;
      await phasesApi.deletePhase(this.shippingId, this.value.id);
      if (this.fromRoute) {
        this.$emit("update");
      } else {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      this.$emit("cancel");
      this.showInfo("Звено удалено");
      this.phaseLoading = false;
    },
    readyForCombinationChanged() {
      this.readyForCombination = !this.readyForCombination;
      this.phaseChanged();
    },
    phaseChanged() {
      this.isChanged = true;
    },
    getPhasesState(state) {
      switch (state) {
        case 1:
          return {
            id: phaseStates.AWAITING,
            value: "Awaiting",
            title: "В ожидании",
          };
        case 4:
          return {
            id: phaseStates.DONE,
            value: "Done",
            title: "Выполнено",
          };
        default:
          return null;
      }
    },
    async addComment(value) {
      this.phaseLoading = true;
      await phasesApi.addComment(this.value.id, value, this.fromRoute);
      const updateComments = await phasesApi.getPhasesComments(
        this.shippingId,
        this.value.id,
      );
      updateComments.forEach(c => {
        if (c.author.id === this.user.id || this.isAdmin) {
          c.disabled = false;
        } else {
          c.disabled = true;
        }
        c.isReaded = true;
      });
      this.currentComments = updateComments;
      this.$emit("add-comment", this.currentComments);
      this.showInfo("Комментарий добавлен");
      this.phaseLoading = false;
    },
    async markAsReadComments() {
      const unreadComments = this.currentComments
        .filter(c => !c.isReaded)
        .map(c => {
          return c.id;
        });
      if (!unreadComments.length) {
        return;
      }
      await phasesApi.markAsReadComments(
        this.shippingId,
        this.value.id,
        unreadComments,
      );
      setTimeout(
        () =>
          this.currentComments.forEach(c => {
            if (!c.isReaded) {
              c.isReaded = true;
            }
          }),
        10000,
      );
      this.$emit("readComments", true);
    },
    async deleteComment(commentId) {
      await phasesApi.deletePhasesComment(this.value.id, commentId);
      const index = this.currentComments.findIndex(c => c.id === commentId);
      this.currentComments.splice(index, 1);
    },
  },
};
</script>
